"use client";

import { useState } from "react";
import SignIn from "@/components/auth/sign-in";
import Image from "next/image";

const inputClasses =
  "h-11 w-full rounded-lg border border-input bg-muted/70 px-3 text-sm shadow-inner outline-none transition placeholder:text-muted-foreground/80 focus-visible:border-primary focus-visible:ring-[3px] focus-visible:ring-primary/20 dark:bg-input/30";

export default function Auth() {
  const [showSignInPassword, setShowSignInPassword] = useState(false);

  return (
    <div className="min-h-screen bg-linear-to-br from-slate-50 via-white to-slate-100 dark:from-background dark:via-background dark:to-background flex flex-col items-center justify-center gap-3 px-4 py-6">
      <div className="mb-6 flex flex-col items-center justify-center">
        <Image
          src="/logo.png"
          alt="EnerQuant Analytics Terminal logo"
          width={128}
          height={128}
        />
        <h2 className="font-semibold text-xl sm:text-3xl">
          EnerQuant Analytics Terminal
        </h2>
      </div>
      <div className="w-full max-w-5xl flex flex-col items-stretch gap-4">
        <SignIn
          inputClasses={inputClasses}
          showSignInPassword={showSignInPassword}
          setShowSignInPassword={setShowSignInPassword}
        />
      </div>
    </div>
  );
}
